import activeWindows from '@/store/modules/active-windows';
import cookies from 'vue-cookies'
import store from '@/store';
import moduleService from '@/configuration/module-service';
import i18n from '../../language/i18n';

var routerWindowService = (function() {

  async function _handleRedirectInWindow (currentRouteObj) {

    const windowIdentifier = _getWindowIdentifier(currentRouteObj);
    if (windowIdentifier == undefined || windowIdentifier.id == undefined) { return }

    let token = cookies.get('token');
    if(token === null || token === undefined) { 
      return;
    }

    const window = await activeWindows.getWindow(windowIdentifier);

    const {
      isUnusualForwarding,
      butForwardingIsIntentional,
      isBrowserBackClicked
    } = _getFlags(window);

    if (isUnusualForwarding && butForwardingIsIntentional) {
      _handleUnusulButIntentionalForwarding();
    } else if (isUnusualForwarding && isBrowserBackClicked) {
      await _handleUnusulForwardingWithBrowserAction(currentRouteObj, windowIdentifier);
    } 

    _handleWindowData(window);
  }

  /**************************************
   * ### HANDLERS ###
   ************************************/
  function _handleUnusulButIntentionalForwarding () {
    store.commit('routingHistory/setIntentionalUnusualForwarding', false);
  }

  async function _handleUnusulForwardingWithBrowserAction (currentRouteObj, windowIdentifier) {
    const routingHistory = store.getters['routingHistory/getCurrentRoutingHistory'] ?? [];
    const lastHistoryObject = routingHistory[routingHistory.length - 1];

    if (lastHistoryObject?.to?.name === currentRouteObj.name &&
      String(lastHistoryObject?.to?.params?.id) === String(currentRouteObj.params.id)) {
      store.dispatch('routingHistory/deleteLastHistoryObject');
    }

    await activeWindows.removeWindow(windowIdentifier);

    store.dispatch('routingHistory/ignoreNextRoutingObject');
    store.dispatch('routingHistory/setBrowserBackToDefaultState');
  }

  function _handleWindowData(window) {
    if (window != undefined && window.data?.isDirty) {
      store.dispatch('globalSnackbarStore/showSnackbarWithMessage', {
        message: i18n.t('Utility.unsavedChanges')
      });
    }
  }

  /**************************************
   * ### HELPERS ###
   ************************************/
  function _getWindowIdentifier (currentRouteObj) {
    const windowIdentifierType = moduleService.findModuleByModuleId(
      currentRouteObj.meta.moduleId
    )?.windowIdentifierType;

    return { type: windowIdentifierType, id: currentRouteObj.params.id };
  }

  function _getFlags (window) {
    const isUnusualForwarding = window?.data !== undefined;
    const butForwardingIsIntentional = store.getters['routingHistory/getIntentionalUnusualForwarding'];
    const isBrowserBackClicked = store.getters['routingHistory/getBrowserBackClicked'];

    return { isUnusualForwarding, butForwardingIsIntentional, isBrowserBackClicked }
  }

  return {
    async handleRedirectInWindow(currentRouteObj) {
      return await _handleRedirectInWindow(currentRouteObj);
    }
  }

})();

export default routerWindowService;
